import { XMarkIcon } from "@heroicons/react/24/outline";
import Navbar from "../../../constants/Navbar"
import { useNavigate } from "react-router";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
export default function OnboardingLinks() {
    const navigate = useNavigate();
    return (
        <>
            <Navbar />
            <div className="p-4 flex flex-col items-center">
                <div className="flex flex-col items-center justify-center p-6 w-3/5 gap-y-6">
                    <div className="w-full flex flex-col text-center items-center justify-center p-6 gap-y-4">
                        <h1 className="text-gray-900 dark:text-gray-100 font-bold text-3xl">Show, Don’t tell us!</h1>
                        <p className="text-gray-900 dark:text-gray-100 font-light text-[14px]">Link to your best work. This is the most important part of your profile. A live demo, a GitHub repo, a design portfolio, or a blog post just anything that shows what you can do.</p>
                    </div>

                    <div className="w-full flex flex-col items-center gap-y-4">
                        <div className="w-4/5 mb-4">
                            <div className="relative">
                                <LinkOutlinedIcon  className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500 dark:text-gray-400" />
                                <input
                                    type="text"
                                    id="links"
                                    className="w-full pl-10 pr-4 h-12 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-lg outline-none focus:border-blue-500"
                                    placeholder="Drop links here!"
                                />
                            </div>
                        </div>
                        <div className="w-4/5 flex flex-row gap-x-4">
                            <div className="p-4 h-12 border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 flex flex-row gap-x-2 items-center rounded-lg">
                                <span className="text-gray-600 dark:text-gray-300 text-[16px] font-medium">Your-Portfolio.com</span>
                                <button type="button">
                                    <XMarkIcon className="size-4 text-blue-600/50 cursor-pointer" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fixed bottom-6 right-8 z-50">
                <button type="button" onClick={() => navigate("/setprofile")} className="text-white h-10 text-center font-medium text-sm bg-blue-700 px-4 rounded-lg cursor-pointer hover:bg-blue-600">
                    Next, review your profile
                </button>
            </div>
        </>
    );
}